import { Skeleton } from '@sea-snag/ui';
import { Navigate, useLocation } from '@tanstack/react-router';

import { useUser } from '../hooks/use-auth';
import { isSignedOutPage } from '../lib/return-path';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isLoading, isAuthenticated } = useUser();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="space-y-4 w-full max-w-md p-4">
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // On the way out this renders once more with the address already on
    // /login; navigating again would replace the page to come back to.
    if (isSignedOutPage(location.pathname)) return null;
    return <Navigate to="/login" search={{ redirect: location.href }} />;
  }

  return <>{children}</>;
}
